import { useState } from "react";
import { Facebook, Twitter, Instagram, Linkedin, Phone, Mail, MapPin, Send, ExternalLink, Building2 } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function Footer() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: "Accueil", path: "/" },
    { name: "Voyage entrant", path: "/venir_au_niger" },
    { name: "Voyage sortant", path: "/sortir_du_niger" },
    { name: "Services", path: "#" },
    { name: "Sites touristiques", path: "#" },
    { name: "Hôtels", path: "#" },
    { name: "Informations", path: "#" },
  ];

  const usefulInfo = [
    { name: "Conditions d'utilisation", path: "#" },
    { name: "Politique de confidentialité", path: "#" },
    { name: "FAQ", path: "/faq" },
    { name: "Aide", path: "#" },
    { name: "Plan du site", path: "#" },
  ];

  const officialLinks = [
    { name: "Présidence de la République", url: "https://www.presidence.ne" },
    { name: "Primature", url: "https://www.primature.ne" },
    { name: "Ministère de l'Intérieur", url: "https://www.interieur.gouv.ne" },
    { name: "Ministère des Affaires Étrangères", url: "https://www.diplomatie.gouv.ne" },
    { name: "Ministère du Tourisme", url: "https://www.tourisme.gouv.ne" },
    { name: "Ministère des Transports", url: "https://www.transports.gouv.ne" },
    { name: "Direction Générale de la Police Nationale", url: "https://www.police.ne" },
    { name: "Office National du Tourisme (ONT)", url: "https://www.ont.ne" },
    { name: "Portail officiel du Gouvernement", url: "https://www.gouv.ne" },
    // { name: "Assemblée Nationale", url: "https://www.assemblee.ne" },
  ];

  const socials = [
    { icon: <Facebook size={16} />, label: "Facebook" },
    { icon: <Twitter size={16} />, label: "Twitter" },
    { icon: <Instagram size={16} />, label: "Instagram" },
    { icon: <Linkedin size={16} />, label: "Linkedin" },
  ];

  const go = (path) => {
    if (!path || path === "#") return;
    navigate(path);
  };

  return (
    <footer className="bg-brand-700 text-white pt-12 pb-6 mt-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Col 1: Logo */}
          <div>
            <div className="flex items-center mb-4">
              <img
                src="/logo_t.png"
                alt="Niger Voyage"
                className="h-28 w-auto object-contain"
              />
            </div>
            <p className="text-white/75 text-xs leading-relaxed mb-4">
              La plateforme officielle des formalités de voyages entrant et sortant au Niger.
            </p>
            <div className="flex gap-2">
              {socials.map((s, i) => (
                <button
                  key={i}
                  aria-label={s.label}
                  className="w-8 h-8 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors"
                >
                  {s.icon}
                </button>
              ))}
            </div>
          </div>

          {/* Col 2: Informations utiles */}
          <div>
            <h4 className="font-bold text-sm mb-3">Informations utiles</h4>
            <ul className="space-y-2">
              {usefulInfo.map((l) => (
                <li key={l.name}>
                  <button
                    onClick={() => go(l.path)}
                    className="text-white/75 hover:text-white text-xs transition-colors"
                  >
                    {l.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Col 3: Contact */}
          <div>
            <h4 className="font-bold text-sm mb-3">Contactez-nous</h4>
            <ul className="space-y-3 text-xs text-white/80">
              <li className="flex items-center gap-2">
                <Phone size={13} /> +227 20 72 00 00
              </li>
              <li className="flex items-center gap-2">
                <Mail size={13} /> contact@nigervoyage.ne
              </li>
              <li className="flex items-center gap-2">
                <MapPin size={13} /> Niamey, Niger
              </li>
            </ul>
          </div>

          {/* Col 4: Newsletter */}
          <div>
            <h4 className="font-bold text-sm mb-3">Newsletter</h4>
            <p className="text-white/75 text-xs mb-3 leading-relaxed">
              Abonnez-vous pour recevoir les dernières informations.
            </p>
            <form
              onSubmit={(e) => e.preventDefault()}
              className="flex items-center bg-white rounded-lg p-1"
            >
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Votre email"
                className="flex-1 px-3 py-1.5 text-xs text-slate-800 bg-transparent focus:outline-none"
              />
              <button
                type="submit"
                className="w-8 h-8 rounded-md bg-brand-600 hover:bg-brand-700 text-white flex items-center justify-center transition-colors"
                aria-label="S'abonner"
              >
                <Send size={14} />
              </button>
            </form>
          </div>
        </div>

        {/* Navigation rapide */}
        {/* <div className="border-t border-white/10 pt-6 mb-6">
          <h4 className="font-bold text-sm uppercase tracking-wide text-white mb-4">
            Navigation rapide
          </h4>
          <ul className="flex flex-wrap gap-x-5 gap-y-2">
            {quickLinks.map((l) => (
              <li key={l.name}>
                <button
                  onClick={() => go(l.path)}
                  className="text-white/75 hover:text-white text-xs transition-colors"
                >
                  {l.name}
                </button>
              </li>
            ))}
          </ul>
        </div> */}

        {/* Liens utiles — institutions officielles */}
        <div className="border-t border-white/10 pt-6 mb-6">
          <div className="flex items-center gap-2 mb-4">
            <Building2 size={16} className="text-white/80" />
            <h4 className="font-bold text-sm uppercase tracking-wide text-white">
              Liens utiles
            </h4>
          </div>
          <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-x-4 gap-y-2">
            {officialLinks.map((l) => (
              <li key={l.name}>
                <a
                  href={l.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group flex items-center gap-1.5 text-white/75 hover:text-white text-xs transition-colors"
                >
                  <ExternalLink
                    size={11}
                    className="text-white/50 group-hover:text-white transition-colors"
                  />
                  <span className="truncate">{l.name}</span>
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div className="border-t border-white/10 pt-4 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-white/60 text-xs">© {currentYear} Niger Voyage - Tous droits réservés.</p>
          <p className="text-white/50 text-[11px]">
            Plateforme officielle du Gouvernement de la République du Niger
          </p>
        </div>
      </div>
    </footer>
  );
}
